import { render, staticRenderFns } from "./CardBlock.modal.vue?vue&type=template&id=32a39d6e&"
import script from "./CardBlock.modal.vue?vue&type=script&lang=js&"
export * from "./CardBlock.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports